import Box from 'UIKit/Box/Box'
import Image from 'UIKit/Image'
import Link from 'UIKit/Link'
import TransText from 'UIKit/Text/TransText'
import { RouteConfig } from 'config/constants/route'
import { useRouter } from 'hooks/useRouter'
import Column from 'layout/Components/Column'
import { RowCenter } from 'layout/Components/Row'
import { Icons } from 'svgs'
import { StyledContainer } from '../../MenuItem'
import { StyledExtendMenuItem } from '../../style'

const HunnyPlayAppMenu: React.FC<{ isSmall?: boolean }> = ({ isSmall }) => {
  const { pathname } = useRouter()
  const isActive = pathname === RouteConfig.ShortCutPage

  return (
    <StyledExtendMenuItem
      as={Link}
      href={RouteConfig.ShortCutPage}
      borderRadius="4px !important"
      overflow="hidden"
      position="relative"
      mt="4px"
      height="44px !important"
      pr="0px !important"
      borderTop="1px solid rgba(250, 250, 250, 0.08) !important"
      borderBottom="1px solid rgba(250, 250, 250, 0.08) !important"
      id="hunny-app-menu"
      data-tooltip-id={isSmall ? 'common-tip-right' : ''}
      data-tooltip-content="HunnyPlay App"
    >
      <StyledContainer
        width="100%"
        background={
          !isActive
            ? 'transparent'
            : isSmall
            ? 'linear-gradient(90deg, rgba(255, 255, 255, 0.08) 1.89%, rgba(255, 255, 255, 0.00) 108.73%)'
            : 'rgba(255, 255, 255, 0.08)'
        }
      >
        {isSmall ? (
          <RowCenter width="100%" style={{ opacity: isActive ? 1 : 0.6 }}>
            <Icons.CircleArrowDown />
          </RowCenter>
        ) : (
          <RowCenter height="44px">
            <Box width="25px" ml="2px">
              <Image src="/images/shortcut-page/hunny-play-thumbnail.png" height={50} width={64} />
            </Box>
            <Column ml="6px">
              <TransText fontSize="12px" fontWeight={500} letterSpacing="-0.24px" color="rgba(250, 250, 250, 0.50)">
                Install
              </TransText>
              <TransText
                fontSize="14px !important"
                mt="2px"
                fontWeight="700 !important"
                color={isActive ? '#fff !important' : 'unset'}
              >
                HunnyPlay App
              </TransText>
            </Column>
          </RowCenter>
        )}
      </StyledContainer>
    </StyledExtendMenuItem>
  )
}

export default HunnyPlayAppMenu
